import EmptyState from '../../../../components/elements/EmptyState';
import noClicksImage from '../../../../images/no-clicks.webp';
import noDataImage from '../../../../images/no-data.webp';
import noLinksImage from '../../../../images/no-links.webp';
import { useTranslation } from 'react-i18next';

export const LINK_CLICKS_EMPTY_STATES = {
  NO_CLICKS: 'no-clicks',
  NO_DATA: 'no-data',
  NO_LINKS: 'no-links'
};

const EMPTY_STATE_CONTENT = {
  [LINK_CLICKS_EMPTY_STATES.NO_CLICKS]: {
    image: noClicksImage,
    titleKey: 'linkClicks.noClicksTitle',
    descriptionKey: 'linkClicks.noClicksDescription',
    actionLabelKey: 'linkClicks.sharePage',
    openInNewTab: true
  },
  [LINK_CLICKS_EMPTY_STATES.NO_DATA]: {
    image: noDataImage,
    titleKey: 'linkClicks.noDataTitle',
    descriptionKey: 'linkClicks.noDataDescription',
    actionLabelKey: 'linkClicks.resetFilters'
  },
  [LINK_CLICKS_EMPTY_STATES.NO_LINKS]: {
    image: noLinksImage,
    titleKey: 'linkClicks.noLinksTitle',
    descriptionKey: 'linkClicks.noLinksDescription',
    actionLabelKey: 'linkClicks.editPage',
    openInNewTab: true
  }
};

const LinkClicksEmptyState = ({ type, onAction, actionHref }) => {
  const { t } = useTranslation();
  const content = EMPTY_STATE_CONTENT[type];

  if (!content) return null;

  return (
    <EmptyState
      image={content.image}
      title={t(content.titleKey)}
      description={t(content.descriptionKey)}
      actionLabel={t(content.actionLabelKey)}
      onAction={onAction}
      actionHref={actionHref}
      actionTarget={content.openInNewTab ? '_blank' : undefined}
    />
  );
};

export default LinkClicksEmptyState;
